import { ReactElement } from "react";
import { Text, TextProps } from "@chakra-ui/react";

type NumericDataTextProps = TextProps;

export function NumericDataText({
  children,
  ...props
}: Readonly<NumericDataTextProps>): ReactElement {
  return (
    <Text fontFamily="Oswald" {...props}>
      {children}
    </Text>
  );
}
